<template>
  <div class="slide" @click="finish">
    <div></div>
    <div class="content">
      <div v-if="image" class="image" v-bind:style="{backgroundImage: `url('${image}')`}"></div>
      <div class="title1 text-center">{{ text }}</div>
    </div>
    <div class="controls">
      <div v-if="buttonText" class="buttonGroup text-center bottom">
        <div class="ghostButton light">{{buttonText}}</div>
      </div>
    </div>
  </div>
</template>

<script>

  import {sleep} from "@/util/sleep";

  export default {
    name: 'Slide',
    components: {},
    props: ['text', 'buttonText', 'image', 'duration'],
    data() {
      return {

      }
    },

    computed: {

    },

    methods: {
      finish: function() {
        this.$emit('finish');
      },
    },

    async created() {
        setTimeout(() => {
          this.finish();
        }, this.duration);

    }
  }
</script>

<style lang="scss">
  @import "src/assets/scss/variables";

  .question {
    display: flex;
    justify-content: space-between;
    flex-direction: column;
    height: 100%;

    .content {
      padding: $bigPadding;

      .image {
        height: 7.5rem;
        width: auto;
        background-size: contain;
        background-position: center;
        margin-bottom: 1.563rem;
      }


      .description {
        font-style: normal;
        color: #2E2F34;
        margin-top: 6.25rem;
        font-weight: normal;
        font-size: $title2FontSize;
        line-height: $title2LineHeight;
        margin: $primaryMargin;
        text-align: center;
      }

    }
  }


</style>
